export enum EmploymentStatusEnum {
  fullTimePermanent = 'fullTimePermanent',
  fullTimeTemporary = 'fullTimeTemporary',
  partTimePermanent = 'partTimePermanent',
  partTimeTemporary = 'partTimeTemporary',
  contract = 'contract',
  selfEmployed = 'selfEmployed',
  unemployed = 'unemployed',
}
